import { motion } from "framer-motion";
import { Check } from "lucide-react";
import PageHeader from "../components/PageHeader";
import { SectionHeading, GradientButton, Reveal } from "../components/primitives";
import { SERVICE_CATEGORIES } from "../data/content";
import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "../components/ui/accordion";

export default function Services() {
  return (
    <div data-testid="services-page">
      <PageHeader
        eyebrow="Our Services"
        title="Everything you need, under one roof"
        sub="Websites, digital security, and trusted IT — delivered with clear communication and a partner mindset."
      />

      <section className="mx-auto max-w-5xl px-5 pb-24 lg:px-8">
        <div className="space-y-6">
          {SERVICE_CATEGORIES.map((cat, i) => (
            <Reveal key={cat.id} delay={i * 0.08}>
              <div
                data-testid={`service-category-${cat.id}`}
                className="overflow-hidden rounded-3xl border border-white/10 bg-white/[0.03]"
              >
                <Accordion type="single" collapsible defaultValue={i === 0 ? cat.id : undefined}>
                  <AccordionItem value={cat.id} className="border-0">
                    <AccordionTrigger
                      data-testid={`service-trigger-${cat.id}`}
                      className="px-8 py-7 hover:no-underline"
                    >
                      <div className="flex items-center gap-4 text-left">
                        <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-brand-gradient shadow-[0_8px_24px_-8px_rgba(255,90,54,0.7)]">
                          <cat.icon className="h-6 w-6 text-white" strokeWidth={2} />
                        </span>
                        <div>
                          <h3 className="font-heading text-xl font-semibold text-white">{cat.title}</h3>
                          <p className="mt-1 text-sm text-muted-foreground">{cat.blurb}</p>
                        </div>
                      </div>
                    </AccordionTrigger>
                    <AccordionContent className="px-8 pb-8">
                      <div className="grid gap-3 border-t border-white/10 pt-6 sm:grid-cols-2">
                        {cat.items.map((item) => (
                          <motion.div
                            key={item}
                            initial={{ opacity: 0, x: -8 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.4 }}
                            className="flex items-center gap-3 rounded-xl border border-white/5 bg-white/[0.02] px-4 py-3"
                          >
                            <Check className="h-4 w-4 shrink-0 text-brand" />
                            <span className="text-sm text-white/85">{item}</span>
                          </motion.div>
                        ))}
                      </div>
                    </AccordionContent>
                  </AccordionItem>
                </Accordion>
              </div>
            </Reveal>
          ))}
        </div>

        <div className="mt-16 flex flex-col items-center gap-6 rounded-3xl border border-white/10 bg-ink-soft p-10 text-center">
          <SectionHeading
            align="center"
            title="Not sure what you need?"
            sub="Tell us about your business and we'll recommend the right approach — no obligation."
          />
          <GradientButton to="/contact" data-testid="services-cta">Book a Free Consultation</GradientButton>
        </div>
      </section>
    </div>
  );
}
